import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import { DietRefDatesStay } from '../Classes/DietRefDatesStay'
import { DietRefDatesStayDto } from '../Type/DietRefDatesStayDto'

export class DietRefDatesStayAPIAdapter implements ApiDataAdapter<DietRefDatesStay> {
    public createClass(apiData: DietRefDatesStayDto): DietRefDatesStay {
        return new DietRefDatesStay(get(apiData, 'dateType'), new Date(get(apiData, 'date')), get(apiData, 'label'))
    }
}
